import { Box } from '@mui/material'
import { NAV_MODE } from './navMode.js'
import styles from './HomeNavPane.module.scss'

const TABS = [
  { id: NAV_MODE.CHAT, label: 'Chat' },
  { id: NAV_MODE.PULSE, label: 'Pulse' },
]

/** Chat / Pulse — which half of the product the rail is listing. */
export default function HomeNavModeTabs({ value, onChange }) {
  return (
    <Box className={styles.modeTrack} role="tablist" aria-label="Sidebar mode">
      {TABS.map((tab) => (
        <button
          key={tab.id}
          type="button"
          role="tab"
          aria-selected={value === tab.id}
          className={`${styles.modeTab}${value === tab.id ? ` ${styles.modeTabActive}` : ''}`}
          onClick={() => onChange(tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </Box>
  )
}
